import { AbstractControl } from '@angular/forms';

export class CustomValidators {
  static trim(str: string): string {
    return str.replace(/\s/g, '');
  }

  static vat(control: AbstractControl) {
    const vatRegex = /^[a-zA-Z]{2}\d{3,10}$/;
    const trimmedValue = CustomValidators.trim(control.value);

    if (!trimmedValue) {
      return null;
    }

    if (vatRegex.test(trimmedValue)) {
      return null;
    }

    return {
      vat: false,
    };
  }
}
